import styled, { css } from 'styled-components';

export const Section = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.v3.spacing.xxxs};
    font-family: ${theme.v3.font.family.brand};
  `}
`;

export const BadgeWrapper = styled.div``;

export const Title = styled.h2`
  ${({ theme }) => css`
    font-size: 30px;
    font-weight: ${theme.v3.font.weights.medium};
    color: ${theme.v3.colors.neutral[5]};
    line-height: ${theme.v3.font.lineHeight.spacious};
    margin: 0;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes['1xlarge']};
    }
  `}
`;

export const GradientSpan = styled.span`
  ${({ theme }) => css`
    background: linear-gradient(
      to right,
      ${theme.v3.colors.brand.snappyOrange[60]},
      color-mix(in srgb, ${theme.v3.colors.accent.pink[60]} 50%, ${theme.v3.colors.brand.snappyOrange[60]})
    );
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: ${theme.v3.font.weights.bold};
  `}
`;

export const Subtitle = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.regular};
    color: #535862;
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin: 0;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes.small};
    }
  `}
`;

export const CardsGrid = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: ${theme.v3.spacing.xxs};
    margin-top: 16px;

    @media (max-width: ${theme.v3.breakpoints.lg}) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: ${theme.v3.breakpoints.md}) {
      grid-template-columns: 1fr;
    }
  `}
`;

export const Card = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.v3.spacing.xs};
    background: #fafafa;
    border-radius: ${theme.v3.border.radius.lg};
    padding: ${theme.v3.spacing.xxs};
    min-width: 280px;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      padding: 20px;
      min-width: unset;
    }
  `}
`;

export const IconPlaceholder = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${theme.v3.icon.size.xl};
    height: ${theme.v3.icon.size.xl};
    background: ${theme.v3.colors.neutral[100]};
    border: 1px solid ${theme.v3.colors.neutral[80]};
    border-radius: ${theme.v3.border.radius.md};
    flex-shrink: 0;
  `}
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CardTitle = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes['1xmedium']};
    font-weight: ${theme.v3.font.weights.medium};
    color: ${theme.v3.colors.neutral[5]};
    line-height: ${theme.v3.font.lineHeight.relaxed};
    margin: 0;
  `}
`;

export const CardText = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.regular};
    color: #535862;
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin: ${theme.v3.spacing.quarck} 0 0 0;
  `}
`;
